<template>
	<div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'layout-login',
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/layouts/layout-login.vue